import type { SupportUserStatus } from "@src/features/tenants";

export type TestSignalsAccess = "pending" | "granted" | "denied";

/**
 * Whether the Test signals page should render its body, wait, or refuse.
 *
 * Auth is the only input allowed to say "wait": `useSupportUserStatus` reports
 * `"pending"` until roles resolve, and denying during that window makes a cold
 * deep-link show the restricted screen permanently. The flag is read from a
 * store that answers `false` for anything it has not loaded, so it cannot be
 * distinguished from a real "off" and is only consulted once auth has settled.
 */
export function resolveTestSignalsAccess(supportStatus: SupportUserStatus, uiFlagEnabled: boolean): TestSignalsAccess {
  if (supportStatus === "pending") return "pending";
  if (supportStatus === "denied") return "denied";
  return uiFlagEnabled ? "granted" : "denied";
}
